import { CreditApplicationStatus } from 'src/services/models/credit.service';
import { FundingSearchStatusOptions } from 'src/services/models/funding.service';
import React from 'react';
import './style.scss';

export enum StatusColors {
    Green = 'green',
    Blue = 'blue',
    Black = 'black',
    Grey = 'grey',
    Red = 'red',
    Yellow = 'yellow',
}

const statusClasses: { [key: string]: StatusColors } = {
    [FundingSearchStatusOptions.FundingApproved]: StatusColors.Green,
    [FundingSearchStatusOptions.ReceivedInProcess]: StatusColors.Black,
    [FundingSearchStatusOptions.Withdrawn]: StatusColors.Grey,
    [FundingSearchStatusOptions.BookedAndPaid]: StatusColors.Blue,
    [FundingSearchStatusOptions.UnableToFund]: StatusColors.Red,
    [CreditApplicationStatus.APPROVED]: StatusColors.Green,
    [CreditApplicationStatus.DECLINED]: StatusColors.Red,
    [CreditApplicationStatus.PENDING]: StatusColors.Black,
    [CreditApplicationStatus.CONDITIONED]: StatusColors.Yellow,
};

interface IStatusDot {
    color: StatusColors;
}

export const statusToStatusClass = (
    status: FundingSearchStatusOptions | CreditApplicationStatus,
): StatusColors => {
    if (status in statusClasses) {
        return statusClasses[status];
    }
    return StatusColors.Black;
};

export const StatusDot: React.FC<IStatusDot> = ({ color }) => {
    return <span className={`dot dot--${color}`}></span>;
};
